import { track } from "../analytics"
import { errorifInvalidPin } from "../pinUtils"
const origin = process.env.REACT_APP_API_ORIGIN ?? ''

export async function pinQueryFunction<TResponse>(path: string, pin: string | null) {
  errorifInvalidPin(pin)
  const url = `${origin}/api/${path}`
  const res = await fetch(url, {
    headers: {
      'Authorization': `Bearer ${pin}`,
      'Content-Type': 'application/json'
    },
  })

  if (res.ok) {
    try {
      const jsonResponse = await res.json()
      return jsonResponse as TResponse
    } catch (e) {
      // Handle empty response
      track('error', 'usePinApiQuery', {}, {
        message: 'Empty success response, returning empty object',
        error: JSON.stringify(e),
      })
      return {} as TResponse
    }
  } else {
    let errorData: any = null
    try {
      errorData = await res.json()
    } catch (e) {
      track('error', 'usePinApiQuery', {}, {
        message: 'Failed to parse error response as JSON',
        error: JSON.stringify(e),
      })
      errorData = { userErrorMessage: 'An error occurred' }
    }
    throw errorData
  }
}
